import he from "he";
import sanitizeHtml from "sanitize-html";

const StringFormatter = {
  truncate(text, maxLength = 80, end = "...") {
    if (text.length <= maxLength || text.length - end.length <= maxLength) {
      return text;
    }

    return String(text).substring(0, maxLength - end.length) + end;
  },

  sanitizeHtml(value) {
    const allowedAttributes = {
      div: ["style", "class", "id"],
      span: ["style", "class"],
      p: ["style", "class"],
      b: ["style", "class"],
      s: ["style", "class"],
      i: ["style", "class"],
      u: ["style", "class"],
      ul: ["style", "class", "type"],
      ol: ["style", "class"],
      li: ["style", "class"],
      strong: ["style", "class"],
      a: ["target", "href", "title", "name", "style", "rel", "class"],
    };

    return sanitizeHtml(he.decode(value), {
      allowedAttributes: { ...sanitizeHtml.defaults.allowedAttributes, ...allowedAttributes },
    });
  },

  stripHtml(value) {
    return sanitizeHtml(value, {
      allowedTags: [],
      allowedAttributes: {},
    });
  },

  encode(value) {
    if (typeof value === "string") {
      return he.encode(he.decode(value));
    }

    if (typeof value === "number") return value;
    return "";
  },

  convertUrlLink(value) {
    let url = sanitizeHtml(he.decode(value));
    // Escape quotes in href attribute to prevent breaking HTML
    const hrefUrl = url.replace(/"/g, "&quot;");
    return `<a target="_blank" href="${hrefUrl}">${url}</a>`;
  },
};

export default StringFormatter;
